import { memo, useRef, useState } from 'react';
import { Markdown } from '@/sub-luca-plugin/compatible-components';
import ActionBar, { IActionBarRef } from './action-bar';
import { isWeApp } from '@/sub-luca-plugin/utils';
import { IAi } from '../index';
import classNames from 'classnames';
import './index.scss';

const AiReply = ({
    recordId,
    reasoningContentState,
    reasoningContent,
    content,
    feedbackType,
    isFeedbackEvaluation,
    permanentActionBar,
}: IAi) => {
    const hoverToolRef = useRef<IActionBarRef>();
    const [collapse, setCollapse] = useState(false);

    // 微信小程序中是点击出现
    const handleClick = () => hoverToolRef.current?.control();

    // PC中是hover出现
    const handleMouseEnter = () => hoverToolRef.current?.show();

    const handleMouseLeave = () => hoverToolRef.current?.hide();

    return (
        <div className="ai-reply">
            {reasoningContent && (
                <>
                    <div
                        className={classNames('ai-reply__reasoning-status', collapse && 'ai-reply__reasoning-status--collapse')}
                        onClick={() => setCollapse(!collapse)}
                    >
                        {reasoningContentState === 0 && '思考中...'}
                        {reasoningContentState === 1 && '思考已停止'}
                        {reasoningContentState === 2 && '已深度思考'}
                    </div>
                    <div
                        className={classNames(
                            'ai-reply__reasoning-content-container',
                            collapse && 'ai-reply__reasoning-content-container--collapse'
                        )}
                    >
                        <Markdown imgType="normal" content={reasoningContent} />
                    </div>
                </>
            )}
            {content && (
                <div
                    className={classNames(
                        'ai-reply__content-container',
                        permanentActionBar && 'ai-reply__content-container--add-padding-bottom'
                    )}
                >
                    <div
                        className="ai-reply__content-markdown-container"
                        onClick={isWeApp ? handleClick : undefined}
                        onMouseEnter={!isWeApp ? handleMouseEnter : undefined}
                        onMouseLeave={!isWeApp ? handleMouseLeave : undefined}
                    >
                        <Markdown imgType="normal" content={content} />
                    </div>
                    {/* 第一期不做 */}
                    <ActionBar
                        ref={hoverToolRef}
                        isPermanent={permanentActionBar}
                        recordId={recordId}
                        content={content}
                        feedbackType={feedbackType}
                        isFeedbackEvaluation={isFeedbackEvaluation}
                    />
                </div>
            )}
        </div>
    );
};

export default memo(AiReply);
